import React from "react";
import { Link } from "react-router-dom";
import UploadInfo from "../UploadInfo";

export default function Footer(props) {
  const theme_color = localStorage.getItem("theme");
  return (
    <>
      <UploadInfo />
      <footer className={props.footerBottom + " bg-" + theme_color}>
        <div className="container">
          <p>
            &copy;copyright <Link to="/">Venom</Link> | All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
